import { Injectable } from '@angular/core';
import { EnvDomainVariables } from './env.service';
@Injectable({ providedIn: 'root' })
export class EnvMagellanUatService {
  getDomainInfo(): EnvDomainVariables {
    return {
      _enableErrorLogging: false,
      _enableRefreshToken: false,
      isMagellan: '1',
      _env: 'magellan-uat',
      _apiUrl: 'https://uat2-api.p-cis.com/api/',
      _production: true,
      _redirectUri: 'https://uat2-login.p-cis.com/',
      _responseType: 'token id_token',
      _issuer: 'https://magellanuatadb2c.b2clogin.com/11f3c9de-7208-4ae2-817b-16d0bc8714b2/v2.0/',
      _strictDiscoveryDocumentValidation: false,
      _tokenEndpoint: 'https://magellanuatadb2c.b2clogin.com.b2clogin.com/magellanuatadb2c.onmicrosoft.com/oauth2/v2.0/token?p=b2c_1_signin',
      _loginUrl: 'https://magellanuatadb2c.b2clogin.com/magellanuatadb2c.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_Signin',
      _clientId: '1ac0dc33-9676-4c75-abae-20989ed4df5a',
      _scope: 'openid profile https://magellanuatadb2c.onmicrosoft.com/api/magellan.read',
      _skipIssuerCheck: true,
      _clearHashAfterLogin: true,
      _oidc: true,
      _logoutUrl: 'https://magellanuatadb2c.b2clogin.com/magellanuatadb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/logout?post_logout_redirect_uri=https://uat2-login.p-cis.com/',
      _signInURL: 'https://magellanuatadb2c.b2clogin.com/magellanuatadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_signin_signup_frp',
      _signInURLSSO: 'https://magellanuatadb2c.b2clogin.com/magellanuatadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_SIGNUP_FRP_SSO',
      _adb2cTenantUrl: 'https://magellanuatadb2c.b2clogin.com/magellanuatadb2c.onmicrosoft.com/oauth2/v2.0/',
      _magicLink: 'https://magellanuatadb2c.b2clogin.com/magellanuatadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_WITH_EMAIL',
      _authEndpoint: 'https://magellanuatadb2c.b2clogin.com/magellanuatadb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/authorize',
      _magicLinkScope: 'https://magellanuatadb2c.b2clogin.com/magellanuatadb2c.onmicrosoft.com/B2C_1A_SIGNIN_WITH_EMAIL/oauth2/v2.0/authorize',
      _launchDarklyClientId: '69120006711aa209b78d9ab0',
      _intercomAppId: 'bqgvwybf',
      _oktaClientId: '0oawylj0k8Lml5eBo1t7',
      _oktaIssuer: 'https://magellanhealth.okta.com',
      _oktaRedirectUri: 'https://uat2-login.p-cis.com/auth/okta/callback',
    };
  }
}
